















































































































































import { Component, Vue } from "vue-property-decorator";
import QRCode from "qrcodejs2";
import cq from "./components/cq.vue";
import cs from "./components/cs.vue";
import cq3 from "./components/cq3.vue";
import contactUs from "@/components/contactUs.vue";
import contactUsNew from "@/components/contactUsNew.vue";
@Component({
  components: { QRCode, cq, cs, cq3, contactUsNew },
})
export default class Home extends Vue {
  public qrcodeBoxOne: any = null;
  public qrcodeBoxTwo: any = null;
  public qrcodeBoxThree: any = null;
  public pages: any = [cq, cs, cq3];
  public nowPage: any = cq;
  public active: any = 1;
  public mounted() {
    this.qrcode();
  }
  public qrcode() {
    this.qrcodeBoxOne = new QRCode("qrcodesOne", {
      width: 68,
      height: 68, // 高度
      text: "http://wpa.qq.com/msgrd?v=3&uin=5285770&site=qq&menu=yes", // 二维码内容
      render: "canvas", // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
    });
    this.qrcodeBoxTwo = new QRCode("qrcodesTwo", {
      width: 68,
      height: 68, // 高度
      text: "https://jq.qq.com/?_wv=1027&k=OSCoEHMB", // 二维码内容
      render: "canvas", // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
    });
    this.qrcodeBoxThree = new QRCode("qrcodesThree", {
      width: 68,
      height: 68, // 高度
      text: "https://jq.qq.com/?_wv=1027&k=tHe1ti1k", // 二维码内容
      render: "canvas", // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
    });
  }
  public handleChange(status) {
    this.nowPage = this.pages[status - 1];
    this.active = status;
  }
}
